import React from 'react';
export var ExperimentsContext = React.createContext(null);
//# sourceMappingURL=ExperimentsContext.js.map